export const CONTRACT_TYPES = Object.freeze({
  CLIENT: "client",
  CLIENT_SUBSCRIPTION: "client-subscription",
  CLIENT_OFFER: "client-offer",
  PARTNER: "partner",
  PRODUCT: "product",
  INTERNAL: "internal",
  MUTUAL_SETTLEMENT: "mutual-settlement",
});

export const CONTRACT_TYPE_TITLE = {
  [CONTRACT_TYPES.CLIENT]: "t-contracts-type.client",
  [CONTRACT_TYPES.CLIENT_SUBSCRIPTION]: "t-contracts-type.client-subscription",
  [CONTRACT_TYPES.CLIENT_OFFER]: "t-contracts-type.client-offer",
  [CONTRACT_TYPES.PARTNER]: "t-contracts-type.partner",
  [CONTRACT_TYPES.PRODUCT]: "t-contracts-type.product",
  [CONTRACT_TYPES.INTERNAL]: "t-contracts-type.internal",
  [CONTRACT_TYPES.MUTUAL_SETTLEMENT]: "t-contracts-type.mutual-settlement",
};

export const CONTRACT_TYPES_LIST = Object.keys(CONTRACT_TYPES).map((key) => {
  return {
    id: CONTRACT_TYPES[key],
    title: CONTRACT_TYPE_TITLE[CONTRACT_TYPES[key]],
  };
});
